var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",attrs:{"colspan":"6"}},[_c('div',{class:{ 'mt-4 d-inline-block section-loading': _vm.loading },staticStyle:{"height":"20px","width":"30px"}}),_c('h3',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }